module.exports = __webpack_public_path__ + "static/img/course-2020Helloween.44fffe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Helloween2020/course-2020Helloween.png
// module id = Lp+R
// module chunks = 1